import * as actionTypes from "../ActionTypes";

const initialState = {
  churchPrayersList: [],
  churchPrayersLoading: false,
  churchPrayersError: null,

  channelPrayersList: [],
  channelPrayersLoading: false,
  channelPrayersError: null,

  ministryPrayersList: [],
  ministryPrayersLoading: false,
  ministryPrayersError: null,
};

const prayersReducer = (state = initialState, action) => {
  switch (action.type) {

    // CHURCH PRAYERS
    case actionTypes.READ_CHURCH_PRAYERS_REQUEST:
      return {
        ...state,
        churchPrayersLoading: true,
        churchPrayersError: null,
        churchPrayersList: [],
      };

    case actionTypes.READ_CHURCH_PRAYERS_SUCCESS:
      return {
        ...state,
        churchPrayersLoading: false,
        churchPrayersList: action.payload?.data || [],
      };

    case actionTypes.READ_CHURCH_PRAYERS_FAIL:
      return {
        ...state,
        churchPrayersLoading: false,
        churchPrayersError: action.payload,
        churchPrayersList: [],
      };

    // CHANNEL PRAYERS
    case actionTypes.READ_CHANNEL_PRAYERS_REQUEST:
      return {
        ...state,
        channelPrayersLoading: true,
        channelPrayersError: null,
        channelPrayersList: [],
      };

    case actionTypes.READ_CHANNEL_PRAYERS_SUCCESS:
      return {
        ...state,
        channelPrayersLoading: false,
        channelPrayersList: action.payload?.data || [],
      };

    case actionTypes.READ_CHANNEL_PRAYERS_FAIL:
      return {
        ...state,
        channelPrayersLoading: false,
        channelPrayersError: action.payload,
        channelPrayersList: [],
      };

    // MINISTRY PRAYERS
    case actionTypes.READ_MINISTRY_PRAYERS_REQUEST:
      return {
        ...state,
        ministryPrayersLoading: true,
        ministryPrayersError: null,
        ministryPrayersList: [],
      };

    case actionTypes.READ_MINISTRY_PRAYERS_SUCCESS:
      return {
        ...state,
        ministryPrayersLoading: false,
        ministryPrayersList: action.payload?.data || [],
      };

    case actionTypes.READ_MINISTRY_PRAYERS_FAIL:
      return {
        ...state,
        ministryPrayersLoading: false,
        ministryPrayersError: action.payload,
        ministryPrayersList: [],
      };

    default:
      return state;
  }
};

export default prayersReducer;
